var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`bs-wrapper sh-button ${
      _vm.disabled ? 'disabled' : _vm.type
    } flex-col ${_vm.size}-size`,on:{"click":function($event){_vm.disabled || _vm.$emit('click')}}},[_c('span',[_c(_vm.loading ? 'loading' : 'span',{tag:"component",attrs:{"type":"spinner","size":"24px"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }